module.exports = __webpack_public_path__ + "img/f.0e80b00e.svg";